// 登录成功之后需执行的预设命令
export enum LoginSuccessCommand {
  openBuyGroupVipPop = "openBuyGroupVipPop",
  resumeHomePrompt = "resumeHomePrompt",
}

export type LoginPromptResumeAction =
  | "fill"
  | "restoreDraft"
  | "startConversation"
  | "saveTemplate";

export interface ResumeHomePromptPayload {
  content: string;
  templateSceneId: string;
  pathname: string;
  search: string;
  resumeAction?: LoginPromptResumeAction;
}

export type LoginSuccessAction =
  | {
      command: LoginSuccessCommand.openBuyGroupVipPop;
    }
  | {
      command: LoginSuccessCommand.resumeHomePrompt;
      payload: ResumeHomePromptPayload;
    };

const isResumeHomePromptPayload = (
  value: unknown,
): value is ResumeHomePromptPayload => {
  if (!value || typeof value !== "object") return false;

  const payload = value as Partial<ResumeHomePromptPayload>;
  const validResumeAction =
    payload.resumeAction === undefined ||
    ["fill", "restoreDraft", "startConversation", "saveTemplate"].includes(
      payload.resumeAction,
    );

  return (
    typeof payload.content === "string" &&
    payload.content.trim().length > 0 &&
    typeof payload.templateSceneId === "string" &&
    typeof payload.pathname === "string" &&
    typeof payload.search === "string" &&
    validResumeAction
  );
};

/**
 * 兼容历史上只保存命令字符串的格式，并拒绝执行被篡改的 sessionStorage 数据。
 */
export const parseLoginSuccessAction = (
  value: string | null,
): LoginSuccessAction | null => {
  if (!value) return null;

  if (value === LoginSuccessCommand.openBuyGroupVipPop) {
    return { command: LoginSuccessCommand.openBuyGroupVipPop };
  }

  try {
    const action = JSON.parse(value) as {
      command?: unknown;
      payload?: unknown;
    };

    if (action.command === LoginSuccessCommand.openBuyGroupVipPop) {
      return { command: LoginSuccessCommand.openBuyGroupVipPop };
    }

    if (
      action.command === LoginSuccessCommand.resumeHomePrompt &&
      isResumeHomePromptPayload(action.payload)
    ) {
      return {
        command: LoginSuccessCommand.resumeHomePrompt,
        payload: action.payload,
      };
    }
  } catch {
    // 非法或旧格式数据不应阻塞应用初始化。
  }

  return null;
};

export const serializeLoginSuccessAction = (
  action: LoginSuccessAction,
): string => JSON.stringify(action);
